import React from "react";
import {
  TextInput,
  required,
  FormDataConsumer,
  maxLength,
  minLength,
  PasswordInput,
} from "react-admin";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";
import { DriverEmailInput } from "./DriverEmailInput";

interface Props {
  edit?: boolean;
}

export const IdAndEmailInput = ({ edit, ...props }: Props) => {
  return (
    <div className="two-inputs-container">
      <ProtectedElement source="driverId">
        <TextInput
          source="driverId"
          label="resources.admin-drivers.labels.driverId"
          validate={[required(), maxLength(16), minLength(4)]}
          {...props}
        />
      </ProtectedElement>
      <FormDataConsumer>
        {(formDataProps) => <DriverEmailInput {...formDataProps} {...props} />}
      </FormDataConsumer>
      {!edit ? (
        <PasswordInput
          source="password"
          label="resources.admin-drivers.labels.password"
          validate={[required(), minLength(4)]}
          {...props}
        />
      ) : null}
    </div>
  );
};
